var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fileReady)?_c('div',[_c('div',{style:(("height: calc(100vh - " + _vm.minusHeight + "px)")),attrs:{"id":("pdf_" + _vm.propFileId)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }